import React, { useState } from "react";
import "./SecondSection.css";
import tiltMobile from "./../../Images/tilt-mobile.png";
import leftSlide from "./../../Images/left-slide.png";
import rightSlide from "./../../Images/right-slide.png";
import WhatsappIcon from "./../../Images/whatsapp.png";
import { useNavigate } from "react-router-dom";
import EnquirePopup from "../EnquirePopup";

const fronturl = process.env.REACT_APP_FRONTEND_URL;

const SecondSection = () => {
  const navigate = useNavigate(null);
  const [showPopup, setShowPopup] = useState(false);



  const handlePopup = () => {
    setShowPopup(true);
  };
  
  const closePopup = () => {
    setShowPopup(false);
  };
  return (
    <>
      <div className="second-sec">
        <div className="container border-blue">
          <div className="row align-center">
            <div className="col-md-12 col-lg-7 relative">
              <img src={tiltMobile} />
              <div className="left-slide">
                {" "}
                <img src={leftSlide} />{" "}
              </div>
              <div className="right-slide">
                {" "}
                <img src={rightSlide} />
              </div>
            </div>
            <div className="col-md-12 col-lg-5 second-text">
              <h2>Business cards can be customized in a few clicks!</h2>
              <h5>
                Personality is unique to each individual. Your card can be
                designed and customized using Businessbay. Make a great first
                impression and make connections with a tap.
              </h5>
              <a style={{ cursor: "pointer" }} 
              onClick={handlePopup}
              className="green-button">
                {/* <img src={WhatsappIcon} style={{width:"36px", height:"36px"}}/> */}
                Get Custom Cards 
              </a>

              {/* <div
                style={{cursor:"pointer"}}
                // onClick={() => navigate("/register")}
                // onClick={() => window.location.href = `${fronturl}register`}
                onClick={() => window.open(`${fronturl}register`, '_blank')}

                className="red-button"
              >
                Design Your Card 
              </div> */}
            </div>
          </div>
          {showPopup && (
               <EnquirePopup  open={showPopup} onClose={closePopup} setOpen={setShowPopup}/>
              )}
        </div>
      </div>
    </>
  );
};

export default SecondSection;
